<template>
  <CustomPage title="浏览记录">
    <div slot="content" style="height: 100%">
      <List
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        class="px-3 pb-2"
        finished-text="没有更多了"
      >
        <div
          v-for="item in recordList"
          :key="item.partGoodsId"
          class="flex justify-between mx-1 mt-2"
          @click="
            () => {
              if (item.state !== 'FINISHED')
                $router.push({
                  name: 'HistoryGoodsDetail',
                  params: { id: item.partGoodsId },
                });
            }
          "
        >
          <div class="flex-shrink-0 mr-2" style="height: 116px; width: 116px">
            <img class="h-full w-full rounded-md" :src="item.goodsImage" />
          </div>
          <div class="flex-grow flex flex-col justify-between">
            <div class="text-sm">
              {{ item.goodsName }}
            </div>
            <div class="text-red font-semibold">
              <span class="text-sm">¥</span
              ><span class="text-2xl mr-1">{{
                (item.actPrice + item.distMarkup).toFixed(2)
              }}</span
              ><span v-distributor="true"
                ><span class="text-xxs">省赚</span
                ><span class="text-xs">{{ item.saveProfit }}</span
                ><span class="text-xxs">元</span></span
              ><span
                v-distributor="false"
                class="line-through text-gray text-xs font-normal"
                >¥{{ item.linePrice }}</span
              >
            </div>
            <div class="flex items-end justify-between">
              <div class="text-xxs flex items-center">
                <span
                  style="
                    width: 3.5rem;
                    display: inline-block;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  "
                  >{{ item.actName }}</span
                ><Icon name="arrow" />
              </div>
              <div v-if="item.state === 'FINISHED'" class="text-sm text-gray">
                活动已结束
              </div>
              <div v-else class="text-left flex-shrink-0 flex items-end">
                <Countdown
                  :startTime="item.start"
                  :endTime="item.end"
                  :padding="0"
                />
              </div>
            </div>
          </div>
        </div>
      </List>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import { Icon, List } from "vant";
import Countdown from "@/components/activity/Countdown";
import { getGoodsRecord } from "./webApi";
export default {
  components: { CustomPage, CustomView, Icon, Countdown, List },
  data() {
    return {
      page: 0,
      size: 10,
      loading: false,
      finished: false,
      recordList: [],
    };
  },
  methods: {
    onLoad() {
      getGoodsRecord({
        page: this.page,
        size: this.size,
      }).then(({ data }) => {
        this.recordList = this.recordList.concat(data.content);

        this.page++;
        if (data.totalElements <= this.recordList.length) {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style scoped>
</style>